// extracted by mini-css-extract-plugin
module.exports = {"lazyImage":"lazy-image-module--lazyImage--15Yk-","lazyImageLoaded":"lazy-image-module--lazyImageLoaded--359RK"};